import React from 'react';
import { CYOA_NETWORK_IDS } from '../../../config';

const BuilderCardStatic = (props) => {
  
  const destination = (props.cyoaId === CYOA_NETWORK_IDS["usa"].id) ? CYOA_NETWORK_IDS["usa"].name : CYOA_NETWORK_IDS["europe"].name;
  const fillColour = (props.cyoaId === CYOA_NETWORK_IDS["usa"].id) ? "#3ABCCB" : "#FF6700";
  const description = (props.cyoaId === CYOA_NETWORK_IDS["usa"].id) ? 'Create your perfect USA trip itinerary using private, door-to-door coaches that connect 8 of the best destinations on the West Coast.' : 'Create your own Euro trip itinerary from our network of 38 destinations in 14 countries and link-up with sailing, festivals & adventure trips.';

  return (
    <div className="columns small-12 medium-6 large-4">
      <a href={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_BUILDER_PAGE}?destination=${destination}`} className={`builder--card-static ${destination}`}>
        <div className="row">
          <div className="columns small-12">
            <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
                <path fill={fillColour} fillRule="evenodd" d="M0 24c0 13.2548 10.7452 24 24 24 13.2486-.015 23.985-10.7514 24-24C48 10.7452 37.2548 0 24 0S0 10.7452 0 24h2.5263c0-11.8596 9.614-21.4737 21.4737-21.4737C35.854 2.5397 45.4603 12.146 45.4737 24c0 11.8596-9.6141 21.4737-21.4737 21.4737S2.5263 35.8596 2.5263 24H0z"/>
                <path fill={fillColour} fillRule="evenodd" d="M28.5444 25.2632H24c-.6976 0-1.2632-.5656-1.2632-1.2632v-4.5447c0-.6976.5656-1.2632 1.2632-1.2632.6976 0 1.2632.5656 1.2632 1.2632v3.2815h3.2812c.6976 0 1.2632.5656 1.2632 1.2632 0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                <path fill={fillColour} fillRule="evenodd" d="M24 36.6316c-.6976 0-1.2632-.5656-1.2632-1.2632v-7.3066c0-.6976.5656-1.2631 1.2632-1.2631.6976 0 1.2632.5655 1.2632 1.2631v7.3066c0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                <path fill={fillColour} fillRule="evenodd" d="M24 16.6934c-.6976 0-1.2632-.5655-1.2632-1.2632v-2.7986c0-.6976.5656-1.2632 1.2632-1.2632.6976 0 1.2632.5656 1.2632 1.2632v2.7983A1.2632 1.2632 0 0 1 24 16.6934z"/>
                <path fill={fillColour} fillRule="evenodd" d="M19.851 25.2632h-7.2194c-.6976 0-1.2632-.5656-1.2632-1.2632 0-.6976.5656-1.2632 1.2632-1.2632h7.2194c.6976 0 1.2631.5656 1.2631 1.2632 0 .6976-.5655 1.2632-1.2631 1.2632z"/>
                <path fill={fillColour} fillRule="evenodd" d="M35.3684 25.2632H32.693c-.6977 0-1.2632-.5656-1.2632-1.2632 0-.6976.5655-1.2632 1.2632-1.2632h2.6755c.6976 0 1.2632.5656 1.2632 1.2632 0 .6976-.5656 1.2632-1.2632 1.2632z"/>
            </svg>
            <div className="builder--card-content">
              <h3 className="title">Create</h3>
              <p className="itinerary-text">Your own {destination} itinerary </p>
              <p className="description no-margin">{description}</p>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}

export default React.memo(BuilderCardStatic);



// WEBPACK FOOTER //
// ./src/components/discover/components/builder-card-static.js